// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as PilotMultiChoiceOptionContainer$LiteracyplanetTupperware from "./PilotMultiChoiceOptionContainer.res.mjs";

function PilotRadioButtonMultiChoice(props) {
  var __group = props.group;
  var group = __group !== undefined ? Caml_option.valFromOption(__group) : "SingleResponse";
  return React.createElement(PilotMultiChoiceOptionContainer$LiteracyplanetTupperware.make, {
              group: group,
              questionIndex: props.questionIndex,
              responseOptionId: props.responseOptionId,
              children: props.children
            });
}

var make = PilotRadioButtonMultiChoice;

export {
  make ,
}
/* react Not a pure module */
